import styled from 'styled-components';

export const Container = styled.div`
  width: 15%;
  min-height: 100%;
  max-height: 100%;
  display: flex-start;
  background-color: ${({ theme }) => theme.colors.background_white};
  align-items: center;
  justify-content: center;
  margin: none;
  padding: 1rem 1.5rem;

  .Title {
    font-weight: 500;
    font-size: 26px;
    color: ${({ theme }) => theme.colors.secondary};
    white-space: nowrap;
  }

  a {
    font-weight: 400;
    font-size: 1.2rem;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primary};
  }

  .LinkMenuLeftActive {
    font-weight: 600;
    font-size: 1.4rem;
  }

  .add-list-favorites {
    h3 {
      font-weight: 400;
      font-family: 'Futura PT';
      font-size: 20px;
      text-decoration: none;
      color: ${({ theme }) => theme.colors.secondary};
      margin: 1.5rem 0 0 2rem;
    }

    .list-lists-contacts {
      margin-left: 2.3rem;
      max-height: 29.8rem;
      max-width: 10rem;
      overflow-y: auto;

      ::-webkit-scrollbar {
        width: 5px;
        background-color: ${({ theme }) => theme.colors.background_white};
      }

      ::-webkit-scrollbar:horizontal {
        height: 5px;
      }

      ::-webkit-scrollbar-track,
      ::-webkit-scrollbar-track-horizontal {
        border-radius: 10px;
      }

      ::-webkit-scrollbar-thumb,
      ::-webkit-scrollbar-thumb:horizontal {
        background-color: ${({ theme }) => theme.colors.tertiary_500};
        border-radius: 10px;
      }

      .item-list {
        max-width: 9.5rem;
        min-width: 9.5rem;

        .select-list,
        .selected-list {
          padding: 0.3rem;
          display: flex;
          justify-content: flex-start;
          width: 100%;
          transition: opacity 0.2s;
          margin-bottom: 0.3rem;
          height: 2.4rem;

          p {
            font-size: 1.2rem;
            font-weight: 300;
          }
        }

        .select-list:hover {
          p {
            text-decoration: 1px underline;
          }
        }

        .selected-list {
          p {
            font-weight: 500;
            text-decoration: 1px underline;
          }
        }

        .select-item-info {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          min-width: 100%;

          .content-photo-list {
            max-width: 29px;
            width: 29px;
            max-height: 29px;
            height: 29px;
            border-radius: 50%;
            box-shadow: 1px 3px 6px #00000029;
            border-radius: 50%;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: ${({ theme }) => theme.colors.background};

            svg {
              max-width: 1.2rem;
              max-height: 1.2rem;
              display: flex;
              align-self: center;
              justify-content: center;
            }
          }

          p {
            display: flex;
            font-weight: book;
            font-size: 20px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: ${({ theme }) => theme.colors.primary};
          }
        }
      }
    }
  }

  .button-add {
    background: transparent;
    border: none;
    cursor: pointer;
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.primary};
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    font-weight: 300;

    :hover {
      text-decoration: underline;
    }

    svg {
      width: 0.8rem;
      height: 0.8rem;
      fill: ${({ theme }) => theme.colors.primary}!important;
      margin-left: 0.3rem;
    }

    margin-left: 2rem;
  }

  @media (max-width: 950px) {
    width: auto;
  }

  @media (max-width: 320px) {
    padding: 0.5rem;
  }
`;

export const Content = styled.nav`
  display: flex;
  margin-top: 1rem;

  .NavBar {
    width: 100%;
    padding: 0 1rem;
    //height: 12rem;
    color: ${({ theme }) => theme.colors.primary};
    border: 1px solid ${({ theme }) => theme.colors.primary};
    border-top: none;
    border-right: none;
    border-bottom-left-radius: 0.6rem;
  }

  .LinkMenuLeft {
    font-weight: 400;
    font-size: 20px;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primary};

    &.active {
      font-weight: bold;
    }
  }

  .DivOption {
    margin-bottom: 0.7rem;
    transition: opacity 0.2s;
    &:hover,
    &:focus {
      opacity: 0.55;
    }
  }

  .NavBarContacts {
    padding: 0 1rem;
    height: 7.5rem;
    color: ${({ theme }) => theme.colors.primary};
    margin-left: 2rem;
    border: 1px solid ${({ theme }) => theme.colors.primary};
    border-top: none;
    border-right: none;
    border-bottom-left-radius: 0.6rem;
    margin-bottom: 0.5rem;
  }

  .NavBarDemanda {
    padding: 0 1rem;
    height: 8rem;
    color: ${({ theme }) => theme.colors.primary};
    margin-left: 2rem;
    border: 1px solid ${({ theme }) => theme.colors.primary};
    border-top: none;
    border-right: none;
    border-bottom-left-radius: 0.6rem;
    margin-bottom: 0.5rem;
  }

  @media (max-width: 950px) {
    .NavBar {
      display: flex;
      flex-direction: row;
      justify-content: center;
      gap: 1rem;
      flex-wrap: wrap;
      padding-left: 0.2rem;
    }
  }

  @media (max-width: 560px) {
    .NavBar {
      gap: 1rem;
      justify-content: center;
    }

    .DivOption {
      margin-bottom: 0;
    }
  }

  @media (max-width: 350px) {
    .NavBar {
      padding: 0.1rem;
      gap: 1rem;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
`;
